export default __webpack_public_path__ + "static/media/empty-box-transparent.d75ef9b7.svg";